import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { Md5 } from 'ts-md5/dist/md5';
// import isRetina from "is-retina";

// Fixed Vkontakte api version
const /** @type {?} */ VkApiVersion = 5.8;
export class AvatarService {
/**
 * @param {?} http
 */
constructor(private http: HttpClient) { }
/**
 * @param {?} id
 * @return {?}
 */
fetchSkypeAvatar(id: string) {
    return 'https://api.skype.com/users/' + id + '/profile/avatar';
  }
/**
 * @param {?} id
 * @param {?} width
 * @param {?} height
 * @return {?}
 */
fetchFacebookAvatar(id: string, width: number, height: number) {
    return 'https://graph.facebook.com/' + id + '/picture?width=' + width + '&height=' + height;
  }
/**
 * @param {?} id
 * @param {?} size
 * @return {?}
 */
fetchGithubAvatar(id: string, size: number): Observable<any> {
    let /** @type {?} */ url = 'https://api.github.com/users/' + id;
    return this.http.get(url).map(profile => {
      return profile['avatar_url'] + '&s=' + size;
    }).catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
/**
 * @param {?} id
 * @param {?} size
 * @return {?}
 */
fetchGoogleAvatar(id: string, size: number): Observable<any> {
    let /** @type {?} */ url = 'https://picasaweb.google.com/data/entry/api/user/' + id + '?alt=json';
    return this.http.get(url).map(profile => {
      let /** @type {?} */ avatarSrc = profile['entry'].gphoto$thumbnail.$t;
      return avatarSrc ? avatarSrc.replace('s64', 's' + size) : '';
    }).catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
/**
 * @param {?} id
 * @param {?} size
 * @return {?}
 */
fetchGravatar(id: string, size: number) {
    let /** @type {?} */ sourceId = id.match('^[a-f0-9]{32}$') ? id : Md5.hashStr(id).toString();
    return 'https://secure.gravatar.com/avatar/' + sourceId + '?s=' + size + 'd=404';
  }
/**
 * @param {?} size
 * @return {?}
 */
_getTwitterImgSize(size: number) {
    if (size <= 24) { return 'mini'; }
    if (size <= 48) { return 'normal'; }
    if (size <= 73) { return 'bigger'; }
    return 'original';
  }
/**
 * @param {?} id
 * @param {?} size
 * @return {?}
 */
fetchTwitterAvatar(id: string, size: number) {
    const /** @type {?} */ s = this._getTwitterImgSize(size);
    return 'https://twitter.com/' + id + '/profile_image?size=' + s;
  }
/**
 * @param {?} size
 * @return {?}
 */
_getVkImgSize(size: number) {
    if (size <= 50) { return 'photo_50'; }
    if (size <= 100) { return 'photo_100'; }
    if (size <= 200) { return 'photo_200'; }
    return 'photo_max';
  }
/**
 * @param {?} id
 * @param {?} size
 * @return {?}
 */
fetchVkontakteAvatar(id: string, size: number): Observable<any> {
    const /** @type {?} */ s = this._getVkImgSize(size);
    let /** @type {?} */ url = 'https://api.vk.com/method/users.get?user_id=' + id + '&v=' + VkApiVersion + '&fields=' + s;
    return this.http.get(url).map(profile => {
      const /** @type {?} */ sizeProperty = Object.keys(profile['response'][0]).pop();
      return profile['response'][0][sizeProperty];
    }).catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function AvatarService_tsickle_Closure_declarations() {
/** @type {?} */
AvatarService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AvatarService.ctorParameters;
/** @type {?} */
AvatarService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
